import * as z from "zod";

export const InviteUserSchema = z.object({
  email: z
    .string()
    .min(1, { message: "Email is required" })
    .email({ message: "Invalid email format" }),
  orgId: z.string().optional(),
});

export const InviteUserConfirmationSchema = z
  .object({
    email: z
      .string()
      .min(1, { message: "Email is required" })
      .email({ message: "Invalid email format" }),
    firstName: z.string().min(3, {
      message: "First Name is required",
    }),
    lastName: z.string().min(3, {
      message: "Last Name is required",
    }),
    password: z
      .string()
      .min(12, {
        message: "Required",
      })
      .regex(/[A-Z]/, { message: "At least one uppercase letter" })
      .regex(/[a-z]/, { message: "At least one lowercase letter" })
      .regex(/\d/, { message: "At least one number" })
      .regex(/[\W_]/, { message: "At least one special character" }),
    confirmPassword: z.string().min(12, {
      message: "Minimum password length is 12",
    }),
    orgId: z.string().optional(),
  })
  .superRefine(({ confirmPassword, password }, ctx) => {
    if (confirmPassword !== password) {
      ctx.addIssue({
        code: "custom",
        message: "The passwords did not match",
      });
    }
  });
